import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SeoHead from "@/components/feature/SeoHead";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

export default function CategoryPage() {
  const { slug } = useParams();
  const location = useLocation();
  const category = categories.find((c) => c.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-error-warning-line text-3xl text-primary-500"></i>
            </div>
            <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-2">
              分类不存在
            </h2>
            <Link
              to="/"
              className="text-primary-500 hover:text-primary-600 text-sm"
            >
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const categoryArticles = articles.filter((a) => a.category === category.slug);

  return (
    <>
      <SeoHead
        title={`${category.name} - 夫妻影院`}
        description={`${category.description}，夫妻影院为你精选适合夫妻情侣共同观看的${category.name}电影推荐。`}
        keywords={`${category.name},夫妻影院,夫妻电影,情侣影院,二人世界电影,浪漫电影推荐`}
        canonicalUrl={`https://fuqicinema.com/category/${category.slug}`}
        ogType="website"
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-secondary-200">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", path: "/" },
                { label: category.name },
              ]}
            />
          </div>
        </div>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-8 md:mb-12">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${category.icon} text-2xl md:text-3xl text-primary-500`}></i>
              </div>
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                夫妻{category.name}电影推荐
              </h1>
              <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
                {category.description}
              </p>
            </div>

            <div className="flex items-center gap-2 flex-wrap justify-center mb-8 md:mb-10">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                    cat.slug === slug
                      ? "bg-primary-500 text-white"
                      : "bg-secondary-100 text-foreground-700 hover:bg-secondary-200"
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {categoryArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group bg-background-50 rounded-xl overflow-hidden border border-secondary-200 transition-all duration-300 hover:border-primary-300"
                  >
                    <div className="relative aspect-video overflow-hidden">
                      <img
                        src={article.thumbnail}
                        alt={article.title}
                        title={`${article.title} - 夫妻影院${category.name}推荐`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-black/60 text-white text-xs">
                        {article.rating}分
                      </div>
                    </div>
                    <div className="p-4 md:p-5">
                      <div className="flex items-center gap-3 mb-2">
                        <span className="text-xs text-foreground-500">{article.year}</span>
                        <span className="text-xs text-foreground-500">{article.duration}</span>
                        <span className="text-xs text-foreground-500">{article.readTime}</span>
                      </div>
                      <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                        {article.summary}
                      </p>
                      <div className="flex flex-wrap gap-1.5 mt-3">
                        {article.tags.slice(0, 3).map((tag) => (
                          <span
                            key={tag}
                            className="text-xs text-secondary-700 bg-secondary-100 px-2 py-0.5 rounded-full"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-movie-line text-3xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-600">该分类暂无文章，敬请期待</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}